import React from "react";
import { Layout, NFTAddress } from "../components";
import "../assets/css/token.css";

const NFTAddressPage = () => {
  return (
    <>
      <Layout>
        <NFTAddress />
      </Layout>
    </>
  );
};

export default NFTAddressPage;
